// ABOUTME: Cache key for the calendarItems field
// ABOUTME: Separates a week's query from a by-id menu fetch of the same field

interface CalendarItemsArgs {
  p?: {
    userID?: string
    dates?: string[]
    ids?: string[]
  }
}

/**
 * Code-unit order, the order `sort()` uses without a comparator: a cache key must
 * not depend on the locale, and every write in CalendarItemService addresses the
 * key this order produces.
 */
const byCodeUnit = (a: string, b: string): number => {
  if (a < b) return -1
  if (a > b) return 1
  return 0
}

/**
 * Two different queries read `calendarItems`: the week (by dates) and
 * `calendarItemsFullMenus` (by ids). Keying on the user and the dates alone
 * left every by-id fetch in one dateless slot — the full menu of one day
 * overwrote another's, two open day editors showed the same meal plan, and
 * saving one day wrote the other day's text into it.
 */
export const calendarItemsKeyArgs = (args: Record<string, unknown> | null): string => {
  const p = (args as CalendarItemsArgs | null)?.p
  const userID = p?.userID ?? "unknown"
  const datesKey = [...(p?.dates ?? [])].sort(byCodeUnit).join("_")
  const idsKey = [...(p?.ids ?? [])].sort(byCodeUnit).join("_")

  // Dates keep their original key format: the week's slot is the one every
  // cache write in CalendarItemService addresses.
  return idsKey ? `${userID}__ids_${idsKey}` : `${userID}__${datesKey}`
}
